module.exports = __webpack_public_path__ + "img/证书7.ab548ebb.jpg";